<template>
  <PanelV2
    type="w2"
    mode="simple"
    title="Which type of merchant are you?"
    showGoBack
  >
    <template v-slot:content-solt>
      <div @click="toBranch(item)" class="branch" :key="item.title" v-for="item in branches">
        <div class="left-area">
          <span>{{ item.title }}</span>
          <p>{{ item.desc }}</p>
        </div>
        <div class="right-area">
          <img src="@/assets/pc/icon_arrow down.svg" />
        </div>
      </div>
    </template>
  </PanelV2>
</template>

<script>
  import API from "@/api";
  
  export default {
    name: 'ChooseMerchantType',
    pRouter: 'WhetherBDOMerchant',
    data() {
      return {
        branches: [
          {
            title: 'Individual',
            desc: 'Not yet registered with DTI',
            path: 'IndividualA',
          },
          {
            title: 'Sole Proprietorship',
            desc: 'Registered with DTI',
            path: 'SolePropA',
          },
          {
            title: 'Corporation',
            desc: 'Registered with SEC',
            path: 'CorporationA',
          },
          {
            title: 'Partnership',
            desc: 'Registered with SEC',
            path: 'PartnershipA',
          }
        ],
      }
    },
    methods: {
      toBranch ({path}) {
        const processNoMap = {
          IndividualA: '1',
          SolePropA: '2',
          CorporationA: '3',
          PartnershipA: '4',
        };

        API.chooseBdoProcess({
          token: this.getCookieItem('token'),
          processNo: processNoMap[path] || '1',
        }).then(res => {

          if (res.success) {

            this.routerChange({name: path})
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>

  .panel-v2 {
    .branch {
      cursor: pointer;
      width: 100%;
      height: 70px;
      display: flex;
      margin: 0 0 24px 0;

      .left-area {
        width: 92%;

        span {
          font: normal normal normal 20px/24px Nunito-bold;
          letter-spacing: 0px;
          color: #0072D8;
        }

        p {
          margin: 8px 0 0;
          font: normal normal normal 16px/24px Nunito;
          letter-spacing: 0px;
          color: #2E2E2E;
        }
      }

      .right-area {
        width: 8%;
        img {
          width: 50px;
          transform: rotate(-90deg);
        }
      }
    }
  }
</style>
